<template>
    <span>
        <el-button
        @click="openDialog()"
        :disabled="disabled"
        >
        Добавить файл
        </el-button>
        <el-dialog title="Подтвердите действие" :visible.sync="dialogTableVisible">
            <el-input placeholder="Введите имя файла" v-model="title"></el-input>
            <el-upload
                class="upload-demo m-t-30"
                :action="url"
                :data="returnFileObj"
                :on-success="handleChange"
                :on-error="onError"
                :on-remove="handleRemove"
                :file-list="fileList"
                with-credentials
                :disabled="!title"
                accept=".png,.jpeg,.jpg,.pdf,.doc,.docx,.xls,.xlsx,.txt,.odt,.ods,.zip"
                >
                <el-button :disabled="!title" size="small" type="primary">Выбрать файлы</el-button>
                <div slot="tip" class="el-upload__tip">Файл не должен превышать 10 мб</div>
            </el-upload>

            <span slot="footer" class="dialog-footer">
                <el-button
                    size="mini"
                    @click="dialogTableVisible = false"
                    >
                    Закрыть
                    </el-button>
<!--                 <el-button
                    size="mini"
                    type="primary"
                    @click="dialogTableVisible = true"
                    >
                    Сохранить
                    </el-button> -->
            </span>

        </el-dialog>
    </span>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { BASE_URL, BASE_DOC_URL } from '@/plugins/url-env'

export default {
    data() {
        return {
            dialogTableVisible: false,
            title: '',
            fileList: [],
            url: BASE_URL + '/document',
            valid: false,
            fileId: null,
        }
    },
    props: {
        catalogId: {
            default: null,
            type: Object
        }
    },
    computed: {
        disabled() {
            if(this.catalogId == null) {
                return false
            } else {
                if(this.catalogId.isFolder) {
                    return false
                } else {
                    return true
                }
            }
        },
        returnFileObj() {

            if(this.catalogId == null) {
                return {
                    title: this.title,
                }
            } else {
                return {
                    CatalogId: this.catalogId.id,
                    title: this.title,
                }
            }

        }
    },
    methods: {
        ...mapMutations([
            'addRootCatalog'
        ]),

        openDialog() {
            this.dialogTableVisible = true
            this.title = ''
            this.fileList = []
        },

        handleChange(response, file, fileList) {
           /*  console.log('response', response)
            console.log('file', file)
            console.log('fileList', fileList) */
            this.fileId = response
            let extension = file.name.split('.')
            
            this.$emit('addFile', {
                file: file,
                label: this.title,
                extension: '.' + extension[extension.length-1],
                fileName: response.fileName
            })
            this.title = ''
            //this.fileList = fileList.slice(-3);
        },
        async handleRemove(remove) {
            try {
                await this.$store.dispatch('documentDeleteFile', {
                    id: this.fileId
                })
                this.$emit('loadList')
            } catch(e) {
                this.$ErrorsMod(e)
            }
            //console.log(remove)
        },

        onError(err, param, param2) {
            let error = JSON.parse(JSON.stringify( err ))
            error.data = [(err+'').replace('Error: ', '')]
            //console.log(error)
            this.$ErrorsMod(error)
        }

    }
}
</script>

